import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller, useWatch } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { AllPermissionDropdown } from "../../../../../../../../features/admin/common/Slice";
import Select from "react-select";

import Common_Back_Btn from "../../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";

import {
  GetSingle,
  UpdateIntermediateEquipment,
  GetAllIntermediate,
} from "../../../../../../../../features/admin/quality_management/resource_requirement/equipment/Slice";

import { formatDateForInput } from "../../../../../../../../utils/common";
import { useFieldArray } from "react-hook-form";
import { FixIDS } from "../../../../../../../../utils/fixIDS";

function Intermediate_Check_Edit_Offcanvas({ show, handleClose, id }) {
  const dispatch = useDispatch();
  const [removedFiles, setRemovedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showError, setShowError] = useState(null);

  const [companiesPreview, setCompaniesPreview] = useState(null);
  const [attachPreview, setAttachPreview] = useState(null);

  const all_test_type = useSelector((state) => state.common.all_test_type);
  const all_chemist = useSelector((state) => state.common.all_chemist);
  const allPermissionDropdown = useSelector(
    (state) => state.common.all_permission_dropdown,
  );
  const all_instruments = useSelector(
    (state) => state.common.all_instrument_management,
  );
  const all_test_method = useSelector((state) => state.common.all_test_method);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm();

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "observations",
  });

  useEffect(() => {
    dispatch(AllPermissionDropdown());
  }, [dispatch]);

  /* ---------------- GET SINGLE ---------------- */
  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));

      if (res.meta?.requestStatus === "fulfilled") {
        const data = res.payload.message;

        const observationsData = data.Intermediate_Check_Observations?.map(
          (o) => ({
            value: o.observation_value,
          }),
        ) || [{ value: "" }];

        reset({
          instrument_id:
            all_instruments?.find(
              (opt) => opt.value === data.instrument_management_id,
            ) || null,
          user_id: data.user_id
            ? {
                value: data.user_id,
                label: data?.User?.name || "",
              }
            : null,
          calibrated_by_id: data.calibrated_by_id
            ? {
                value: data.calibrated_by_id,
                label: data?.Calibrated_By?.instrument_name || "",
              }
            : null,
          date: data.date ? formatDateForInput(data.date) : "",
          std_value_in_grams: data.std_value_in_grams || "",
          weight_in_grams: data.weight_in_grams || "",
          remark: data.remark || "",
          observations: observationsData,
        });

        replace(observationsData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (show && id) {
      GetData(id);
    }
  }, [show, id]);

  /* ---------------- SUBMIT ---------------- */
  const onSubmit = async (data) => {
    try {
      const sendData = {
        instrument_id: data.instrument_id?.value,
        calibrated_by_id: data.calibrated_by_id?.value,
        user_id: data.user_id?.value,
        date: data.date,
        accureacy_status: data.accuracy_status,
        std_value_in_grams: data.std_value_in_grams,
        weight_in_grams: data.weight_in_grams,
        remark: data.remark,
        observations: data.observations.map((o) => ({
          value: o.value,
        })),
      };

      const res = await dispatch(UpdateIntermediateEquipment({ id, sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetAllIntermediate());

        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 1500);
      }
    } catch (error) {
      console.error(error);
    }
  };

  /* ---------------- AUTO HIDE SUCCESS ---------------- */
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <Offcanvas
      className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Edit Intermediate Check
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Instrument</Form.Label>
                  {/* Instrument */}
                  <Controller
                    name="instrument_id"
                    control={control}
                    render={({ field }) => (
                      <Select
                        options={all_instruments}
                        value={field.value}
                        onChange={field.onChange}
                      />
                    )}
                  />
                  {errors.instrument_id && (
                    <span className="text-danger">
                      {errors.instrument_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Calibrate Instrument By</Form.Label>
                  {/* User */}
                  <Controller
                    name="user_id"
                    control={control}
                    render={({ field }) => (
                      <Select
                        options={allPermissionDropdown}
                        value={field.value}
                        onChange={field.onChange}
                      />
                    )}
                  />
                  {errors.user_id && (
                    <span className="text-danger">
                      {errors.user_id.message}
                    </span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Calibrated By</Form.Label>
                  <Controller
                    className="select-contoller"
                    name="calibrated_by_id" // name of the field
                    control={control}
                    rules={{
                      required: "Select Calibrated By",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors?.calibrated_by_id
                              ? "red"
                              : baseStyles.borderColor,
                          }),
                        }}
                        options={all_instruments}
                        onBlur={onBlur}
                        value={value}
                        ref={ref}
                        onChange={(selectedValue) => {
                          onChange(selectedValue);
                        }}
                      />
                    )}
                  />

                  {errors.calibrated_by_id && (
                    <Form.Text className="text-danger">
                      {errors.calibrated_by_id.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Weight</Form.Label>
                  <Form.Control
                    {...register("weight_in_grams", {
                      required: "Weight is required",
                    })}
                  />
                  {errors.weight_in_grams && (
                    <span className="text-danger">
                      {errors.weight_in_grams.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>STD</Form.Label>
                  <Form.Control
                    {...register("std_value_in_grams", {
                      required: "STD is required",
                    })}
                  />
                  {errors.std_value_in_grams && (
                    <span className="text-danger">
                      {errors.std_value_in_grams.message}
                    </span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    {...register("date", {
                      required: "Date is required",
                    })}
                  />
                  {errors.date && (
                    <span className="text-danger">{errors.date.message}</span>
                  )}
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Remark</Form.Label>
                  <Form.Control
                    {...register("remark", {
                      required: "Remark is required",
                    })}
                  />
                  {errors.remark && (
                    <span className="text-danger">{errors.remark.message}</span>
                  )}
                </Form.Group>
              </div>

              {/* Observation */}
              <div className="col-12">
                <Form.Group className="form_group">
                  <Form.Label>Observations</Form.Label>

                  <div className="row">
                    {fields.map((field, index) => (
                      <div
                        key={field.id}
                        className="col-xl-2 col-lg-4 col-md-4"
                      >
                        <div className="observation_box">
                          {/* Label */}
                          <div className="obs_label">
                            OBS {String(index + 1).padStart(2, "0")}
                          </div>

                          {/* Input */}
                          <Form.Control
                            {...register(`observations.${index}.value`, {
                              required: "Observation is required",
                            })}
                            defaultValue={field.value} //important for edit
                            onKeyDown={(e) => {
                              if (/[0-9]/.test(e.key)) return;

                              if (
                                e.key === "." &&
                                !e.target.value.includes(".")
                              )
                                return;

                              if (
                                [
                                  "Backspace",
                                  "Delete",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  "Tab",
                                ].includes(e.key)
                              )
                                return;

                              e.preventDefault();
                            }}
                          />

                          {/* Error */}
                          {errors.observations?.[index]?.value && (
                            <small className="text-danger">
                              {errors.observations[index].value.message}
                            </small>
                          )}

                          {/* Remove button */}
                          {fields.length > 1 && (
                            <button
                              type="button"
                              className="remove_btn"
                              onClick={() => remove(index)}
                            >
                              ❌
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Add button */}
                  <div className="mt-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => append({ value: "" })}
                    >
                      Add Observation
                    </button>
                  </div>
                </Form.Group>
              </div>
            </div>
          </div>

          <div className="offcanvas_footer_holder">
            {success ? (
              <Success_Toster successText="Updated Successfully!" />
            ) : (
              <>
                <div className="btns_holder">
                  <Gray_Btn btnText="Cancel" onClick={handleClose} />
                  <Black_Submit_Btn btnText="Submit" type="submit" />
                </div>
                {/* <Refresh_btn /> */}
              </>
            )}
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default Intermediate_Check_Edit_Offcanvas;
